/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useSmallContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FolderBaseDefaultSmall = ({
  className,
  hasWhitespace = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    contentIconRecipe({})
  ]);
  const viewBox = useSmallContentIconViewBox({ hasWhitespace, type: "folder" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FolderBaseDefaultSmall",
      ...props
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.002 7.004c.552.018.993.252 1.295.7l.785 2.12c.145.298.363.576.561.779.252.257.633.4 1.156.4H35.5l-.002 18c-.027.976-.3 1.594-.836 2.142-.565.577-1.383.858-2.41.858H8.748c-1.026 0-1.844-.28-2.409-.858-.564-.577-.838-1.415-.838-2.465V7.003h9.502Z",
        fill: "var(--dig-color__foldericon__shadow, #75aaff)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.002 7.001c.552.018.993.252 1.295.7l.785 2.12c.145.298.363.576.561.779.252.257.633.4 1.156.4H35.5l-.002 16.84c-.027.976-.3 1.754-.836 2.302-.565.577-1.383.858-2.41.858H8.748c-1.026 0-1.844-.28-2.409-.858-.564-.577-.838-1.415-.838-2.465V7l9.502.001Z",
        fill: "var(--dig-color__foldericon__container, #a0c4ff)"
      }
    )
  );
};
export {
  FolderBaseDefaultSmall
};
